document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/products/')) { // Ensure it's a product page

    // Controleer of de popup al eerder getoond is
    if (localStorage.getItem('popupShown')) {
      return; // Stop hier, popup niet meer tonen
    }

    // Function to show the popup
    function showPopup() {
      const popupElement = document.createElement('div');
      popupElement.innerHTML = `
        <div id="popup">
          <p>Geniet van onze bulkkorting door 4 zakken of meer te bestellen! Soorten en diameters kan je combineren. Je ziet de korting verschijnen in je winkelmand.</p>
          <button id="popup-close">X</button>
        </div>
        <div id="popup-overlay"></div>
      `;

      // Append the popup to the body
      document.body.appendChild(popupElement);

      // Sla op dat de popup getoond is
      localStorage.setItem('popupShown', 'true');

      // Add event listeners to close the popup
      document.getElementById('popup-close').addEventListener('click', function() {
        document.body.removeChild(popupElement);
      });

      document.getElementById('popup-overlay').addEventListener('click', function() {
        document.body.removeChild(popupElement);
      });
    }

    // Delay the popup by 2 seconds (2000 milliseconds)
    setTimeout(showPopup, 2000);
  }
});
